import React, { useEffect } from "react";
import { Route, Redirect, useRouteMatch, useLocation, matchPath } from "react-router-dom";
// Sections
import Blog from "./Blog";
import About from "./About";
import Intro from "./Intro";
import Header from "./Header";
import Resume from "./Resume";
import Service from "./Service";
import Contact from "./Contact";
import Portfolio from "./Portfolio";
import Testimonial from "./Testimonial";
import BlogSinglePost from "./BlogSinglePost";
import Process from "./Process";
// Components
import Helmet from "../../components/common/Helmet";
import Switch from "../../components/common/Switch";
import RedirectAs404 from "../../components/common/RedirectAs404";
import ProjectDetail from "./ProjectDetail";
import Slogan from "../../components/common/Slogan";

// import Slider from "react-slick";

const routes = [
    {
        path: "/",
        component: <Intro />,
        slogan:"AI accelerates execution. Experience ensures correctness. I use both - deliberately.",
        title: "Top Rated Plus React Native & Expo Developer (AI-Accelerated)"
    },
    {
        path: "/about",
        component: <About />,
        slogan:"I’m not a great programmer; I’m just a good programmer with good habits.",
        title: "About Gopi Kachhadiya | Trusted React Native Developer with 7+ Years Experience"
    },
    {
        path: "/process",
        component: <Process />,
        slogan:"From Idea To Production-Ready Reality",
        title: "Development Process | Clear, Structured & Reliable Mobile App Delivery"
    },
    {
        path: "/service",
        component: <Service />,
        slogan:"Start developing apps that last.",
        title: "Services | Reliable React Native, Expo & Mobile App Development"
    },
    {
        path: "/portfolio",
        component: <Portfolio />,
        slogan:"Every app is special",
        title: "Portfolio | Production-Ready React Native & Expo Mobile Applications"
    },
    {
        path: "/portfolio/projectDetail/:id",
        component: <ProjectDetail />,
        slogan:"",
        title: "Project Detail | Gopi Kachhadiya"
    },
    {
        path: "/blog",
        component: <Blog />,
        slogan:"",
        title: "Blog | Gopi Kachhadiya"
    },
    {
        path: "/blog/single-post",
        component: <BlogSinglePost />,
        slogan:"",
        title: "Blog Post | Gopi Kachhadiya"
    },
    {
        path: "/testimonial",
        component: <Testimonial />,
        slogan:"I’m not a great programmer; I’m just a good programmer with good habits.",
        title: "Testimonials | What Clients Say About Gopi Kachhadiya"
    },
    {
        path: "/contact",
        component: <Contact />,
        slogan:"Share a few details about your project and I’ll get back to you with clarity and next steps.",
        title: "Contact Gopi Kachhadiya | Hire a Top Rated React Native Developer"
    },
];

function Home() {
    let { path } = useRouteMatch();

    useEffect(() => {
        document.documentElement.className = "home-1 skin-1";
        return () => {
            document.documentElement.className = "";
        };
    });

    const location = useLocation();
    const currentRoute = routes.find(route => 
        matchPath(location.pathname, {
            path: route.path,
            exact: true
        })
    );
    
    var slogan_title = '';
    var page_title = '';
    if (currentRoute) {
        if (currentRoute.slogan) slogan_title = '"' + currentRoute.slogan + '"';
        if (currentRoute.title) page_title = currentRoute.title;
    }
    return (
        <div>
            <Helmet title={page_title} />
            {currentRoute && currentRoute.path !== "/portfolio/projectDetail/:id" && <Header />}
            <Switch>
                                 {routes.map((item, index) => (
                        <Route key={index} path={`${item.path}`} exact>
                            {item.component}
                        </Route>
                    ))}
                <Route component={RedirectAs404} />
            </Switch>

            {slogan_title!=''?<Slogan title={slogan_title}/>:'' }
            
        </div>
    );
}

export default Home;
